import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";

import {
  StyledDropdownHeading,
  StyledHoursWorkedBarContainer,
  StyledHoursWorkedHeader,
  StyledInput,
  StyledP,
  StyledSmallBoldP,
  StyledBreak,
  StyledSelect
} from "./styles";
import HoursWorkedBar from "./hours-worker-bar";
import { getMemberHoursWorked } from "./graphql/get-member-hours-worked";

const HoursWorked = ({ memberId }) => {
  const [selectedPeriod, setSelectedPeriod] = useState("week");
  const [startDate, setStartDate] = useState(
    new Date(
      moment()
        .startOf("isoWeek")
        .format()
    )
  );
  const [endDate, setEndDate] = useState(null);
  const [maxHours, setMaxHours] = useState(48);
  const list = ["week", "month", "quarter", "year"];

  useEffect(() => {
    getEndDate(startDate, selectedPeriod);
    hoursCalculation();
  }, []);

  const { hoursCompleted } = getMemberHoursWorked(memberId, startDate, endDate);

  const getEndDate = async (date, timePeriod) => {
    //change time period text to work with moment
    let timeToAdd = "week";
    switch (timePeriod) {
      case "week":
        timeToAdd = "week";
        break;
      case "month":
        timeToAdd = "months";
        break;
      case "year":
        timeToAdd = "years";
        break;
      default:
        "week";
    }

    let endDate;
    if (timePeriod === "quarter") {
      endDate = moment(date)
        .add(4, "months")
        .format();
    } else {
      endDate = moment(date)
        .add(1, timeToAdd)
        .format();
    }

    // Don't run over into new time period
    // E.g. Mon 0:00:00 - Sun 11:59:59 instead of Mon 0:00:00 - Mon 0:00:00
    const finalDate = endDate
      ? moment(endDate)
          ?.subtract({ seconds: 1 })
          ?.format()
      : null;

    setEndDate(new Date(finalDate));
  };

  const updateSelectedPeriod = period => {
    setSelectedPeriod(period);
    getEndDate(startDate, period);
    hoursCalculation(period);
  };

  const updateStartTime = date => {
    setStartDate(date);
    getEndDate(date, selectedPeriod);
  };

  const hoursCalculation = period => {
    const selectedPeriod = period || selectedPeriod;
    switch (selectedPeriod) {
      case "quarter":
        setMaxHours(48 * 4 * 3);
        break;
      case "month":
        setMaxHours(48 * 4);
        break;
      case "year":
        setMaxHours(48 * 52);
        break;
      default:
        setMaxHours(48);
    }
  };

  return (
    <>
      <StyledDropdownHeading>
        <StyledSmallBoldP>Hours booked this </StyledSmallBoldP>{" "}
        <StyledSelect
          list={list}
          onChange={e => {
            updateSelectedPeriod(e?.target?.value);
          }}
          value={selectedPeriod}
        >
          {list.map((label, i) => (
            <option key={i} value={label}>
              {label}
            </option>
          ))}
        </StyledSelect>
      </StyledDropdownHeading>
      <StyledHoursWorkedBarContainer>
        <StyledP>0 hrs</StyledP>
        <HoursWorkedBar
          hoursCompleted={hoursCompleted}
          hoursCompletedPercentage={Math.round(
            (hoursCompleted / maxHours) * 100
          )}
        />
        <StyledP>{maxHours} hrs</StyledP>
      </StyledHoursWorkedBarContainer>
      <StyledHoursWorkedHeader>
        <StyledP style={{ paddingRight: "5px" }}>For the period:</StyledP>
        <StyledSmallBoldP>from</StyledSmallBoldP>
        <>
          <DatePicker
            placeholderText={"Start date"}
            onChange={date => {
              updateStartTime(date);
              getEndDate(date, selectedPeriod);
            }}
            selected={startDate}
            todayButton={true}
            showYearDropdown
            adjustDateOnChange
            dateFormat="dd/MM/yyyy"
            customInput={<StyledInput />}
          />
        </>
        {endDate && (
          <>
            <StyledSmallBoldP>until</StyledSmallBoldP>
            <DatePicker
              disabled={true}
              placeholderText={"End date"}
              showYearDropdown
              adjustDateOnChange
              selected={endDate}
              dateFormat="dd/MM/yyyy"
              customInput={<StyledInput style={{ color: "#9B9B9B" }} />}
            />
          </>
        )}
      </StyledHoursWorkedHeader>
      <StyledBreak></StyledBreak>
    </>
  );
};

export default HoursWorked;
